{
	"blocks": {
		"body": "Testo",
		"button": "Pulsante",
		"greeting": "Saluto",
		"heading": "Titolo",
		"link_body": "Testo del link",
		"note": "Nota finale",
		"preview": "Anteprima nella casella",
		"subject": "Oggetto"
	},
	"columns": {
		"email": "Email",
		"en": "Inglese",
		"it": "Italiano"
	},
	"content_title": "Contenuto dell'email",
	"default_text": "Testo predefinito",
	"emails": {
		"E1": "Codice di accesso dello studente",
		"G1": "Invito all'account del gestionale",
		"G10": "Nuova struttura affidata a un gestore"
	},
	"error": "Non riesco a caricare i testi. Ricarica la pagina.",
	"history": "Versioni",
	"history_default": "Versione 1, testo predefinito",
	"history_item": "Versione {{version}}, {{date}}, {{name}}",
	"issues": {
		"empty": "Scrivi il testo di questo blocco.",
		"malformed_variable": "C'è una graffa che non fa parte di una variabile: scrivi la variabile con una sola graffa per lato, come {nome}.",
		"missing_variable": "Manca {{variable}}: rimettila nel testo.",
		"repeated_variable": "{{variable}} si può usare una sola volta in questo blocco.",
		"unknown_block": "Questo blocco non esiste in questa email.",
		"unknown_variable": "{{variable}} non si può usare qui."
	},
	"legal": {
		"description": "L'offerta (E9) e le PEC (P1-P4) fanno parte delle regole del bando: non si modificano da qui e si leggono nel bando in PDF di ogni struttura.",
		"title": "Testi con valore legale"
	},
	"locales": {
		"en": "Inglese",
		"it": "Italiano"
	},
	"not_found": "Questa email non ha un testo modificabile.",
	"page_title": "Testi delle email",
	"preview_title": "Anteprima",
	"required": "Obbligatorie: {{variables}}.",
	"save": "Salva una nuova versione",
	"saved": "Nuova versione salvata: le prossime email useranno questo testo.",
	"subject": "Oggetto:",
	"variables": "Variabili:",
	"variables_global": "Puoi usare {piattaforma} in ogni testo: viene sostituito con il nome della piattaforma.",
	"version_on": "Versione {{version}} del {{date}}"
}
